export default __webpack_public_path__ + "static/media/hafiz.04792996.jpg";